<template>
  <div class="chatMessages" :key="index"
       :class="{'flexReverse': chat.senderType === 'AGENT' || chat.senderType === 'SYSTEM'}" v-if="chat.messageType !== 'BROWSER_EXIT'">
    <template v-if="chat.senderType === 'USER' && chat.messageType !== 'HIDE_MESSAGE'">
      <div class="customerProfile">
        <img :src="iconUrl" alt="user-profile" width="30" :class="{'fb': channelName === 'FACEBOOK_TALK'}" />
        <span v-if="userName.length > 6">{{customerNameTruncate(userName)}}</span>
        <span v-else>{{ userName }}</span>
      </div>
      <div class="chatBubbleWrap cbWrapLeft">
        <div class="chatBubble customer">
          <message-photo v-if="chat.messageType === 'PHOTO'" :content="chat.content" :is-last-index="isLastIndex"></message-photo>
          <message-html v-else-if="chat.messageType === 'HTML'" :content="chat.content"></message-html>
          <message-video v-else-if="chat.messageType === 'VIDEO' || chat.messageType ==='AUDIO'"
                         :content="chat.content"></message-video>
          <message-scenario v-else-if="chat.messageType === 'SCENARIO'"
                            :content="chat.content" :sender-type="chat.senderType">
          </message-scenario>
          <message-category v-else-if="chat.messageType === 'COMBINATION'"
                            :content="chat.content" :sender-type="chat.senderType">
          </message-category>
          <message-line v-else-if="chat.messageType === 'LINE'"
                            :content="chat.content" :sender-type="chat.senderType">
          </message-line>
          <message-input v-else-if="chat.messageType === 'INPUT' || chat.messageType === 'LABEL'"
            :content="chat.content" :sender-type="chat.senderType">
          </message-input>
          <span v-else-if="chat.messageType ==='FILE'" class="messageContentWrap">
            <span>{{ parseTextFromContent(chat) }}</span>
            <a :href="parseFileFromContent(chat.content)">{{ parseFileFromContent(chat.content) }}</a>
          </span>
          <span v-else-if="chat.messageType ==='FILE'">{{ parseFileFromContent(chat.content) }}</span>
          <span v-else class="messageContentWrap"
                v-html="parseTextFromContent(chat)"></span>
        </div>
        <span class="messageDate">{{printCreateMessageDateTime(chat.createDate)}}</span>
      </div>
      <v-btn
          @click="openAboutTab(chat.content)"
          v-if="isShowAboutQ"
          class="UXbtn aboutQ"
          flat
          outline
          color="#FFFFFF">
        <i class="UXicon-questions"></i>
      </v-btn>
    </template>

    <template v-else>
      <div v-if="showMessageType(chat)" class="customerProfile">
        <img src="https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/common/icon_profile_default.png" alt="user-profile" width="30"/>
        <span v-if="chat.senderName && chat.senderName.length > 5">{{senderNameTruncate(chat.senderName)}}</span>
        <span v-else>{{ chat.senderName }}</span>
      </div>
      <div v-if="showMessageType(chat)" class="chatBubbleWrap cbWrapRight">
        <div class="chatBubble systemUser">
          <message-photo v-if="chat.messageType === 'PHOTO'" :content="chat.content" :is-last-index="isLastIndex"></message-photo>
          <message-video v-else-if="chat.messageType === 'VIDEO'" :content="chat.content"></message-video>
          <message-scenario v-else-if="chat.messageType === 'SCENARIO'"
                            :content="chat.content" :sender-type="chat.senderType" :preview="true">
          </message-scenario>
          <message-category v-else-if="chat.messageType === 'COMBINATION' || chat.messageType === 'SURVEY'"
                            :content="chat.content" :sender-type="chat.senderType">
          </message-category>
          <message-line v-else-if="chat.messageType === 'LINE'"
            :content="chat.content" :sender-type="chat.senderType">
          </message-line>
          <message-input v-else-if="chat.messageType === 'INPUT' || chat.messageType === 'LABEL'"
            :content="chat.content" :sender-type="chat.senderType">
          </message-input>
          <span v-else class="messageContentWrap" v-html="parseTextFromContent(chat)"></span>
        </div>
        <span class="messageDate right">{{printCreateMessageDateTime(chat.createDate)}}</span>
      </div>
    </template>
  </div>
</template>

<script>
import helper from 'util/helpers'
import util from 'util/'
import messageUtil from 'util/messages'
import messageText from './../../../webchat/message/fragments/message_text'
import messagePhoto from './../../../webchat/message/fragments/message_photo'
import messageVideo from './../../../webchat/message/fragments/message_video'
import messageCategory from './../../../webchat/message/fragments/message_category'
import messageScenario from './../../../webchat/message/fragments/message_scenario'
import messageHtml from './../../../webchat/message/fragments/message_html'
import messageLine from './../../../webchat/message/fragments/message_line'
import messageInput from './../../../webchat/message/fragments/message_input'
import Autolinker from 'autolinker'
import {mapGetters} from 'vuex'

export default {
  name: 'chat_messages',
  components: {
    messageText, messagePhoto, messageVideo, messageCategory, messageScenario, messageHtml, messageLine, messageInput
  },
  props: {
    index: Number,
    chat: Object,
    banWords: Array,
    setBanWordsCount: Function,
    channelName: String,
    userName: String,
    isScenario: Function,
    isLastIndex: Boolean,
    status: String,
    iconUrl: String
  },
  data () {
    return {
      banWordFilteredCount: 0
    }
  },
  computed: {
    ...mapGetters([
      'isUseAboutTalk'
    ]),
    isShowAboutQ () {
      // Q버튼 노출 조건 1. text 타입 2. active 상태 (상담이력에서 숨기기 위함) 3. 금지어를 포함하지 않음 4. 어바웃톡 브랜드
      return this.chat.messageType === 'TEXT' && (this.status === 'ACTIVE' || this.status === 'TRANSFER') && !messageUtil.isContainBanWord(this.banWords, this.chat.content) && this.isUseAboutTalk
    }
  },
  methods: {
    showMessageType (chat) {
      return chat.messageType !== 'TAKE_OVER' && chat.messageType !== 'BROWSER_EXIT' && chat.messageType !== 'CONNECT' && chat.messageType !== 'AUTO_CLOSE' && chat.messageType !== 'BAN_WORD' && !(this.isScenario(chat.channelName) && chat.messageType === 'END')
    },
    parseFileFromContent (content) {
      const jsonContent = JSON.parse(content)
      return jsonContent.url
    },
    parseTextFromContent (chat) {
      if (chat.messageType === 'HIDE_MESSAGE') {
        return
      }
      const jsonContent = JSON.parse(chat.content)
      const filteredText = messageUtil.xssCheck(jsonContent.text)
      if (chat.senderType === 'USER' && chat.messageType === 'TEXT') {
        jsonContent.text = filteredText
        // 고객이 보낸 메세지일 경우 금칙어 필터링
        if (this.banWords) {
          let data = messageUtil.replaceBanWord(this.banWords, jsonContent.text)
          jsonContent.text = data.message
          this.banWordFilteredCount = data.count
        }
      }
      if (this.setBanWordsCount) {
        this.setBanWordsCount(this.banWordFilteredCount)
      }
      if (chat.senderType !== 'SYSTEM' && chat.messageType === 'TEXT' && jsonContent.code === undefined && !this.banWordFilteredCount) {
        jsonContent.text = Autolinker.link(filteredText, {
          stripPrefix: false
        })
      }
      return jsonContent.text
    },
    printCreateMessageDateTime (datetimeString) {
      return helper.printTimeStampMessageFromDateTime(datetimeString)
    },
    customerNameTruncate (customerName) {
      return helper.textTruncate(customerName, 7)
    },
    senderNameTruncate (senderName) {
      return helper.textTruncate(senderName, 6)
    },
    getChannelIcon (moduleChannelName) {
      return util.getChatRoomIcon(moduleChannelName)
    },
    openAboutTab (chatContent) {
      this.$eventBus.$emit('OPEN_ABOUT_PET_QNA_TAB', chatContent)
    },
    htmlConverter (content) {
      const jsonContent = JSON.parse(content)
      console.log(jsonContent.text)
      return jsonContent.text
    }
  }
}
</script>

<style lang="scss">
  .chatMessages {
    display: flex;
    padding-top: 30px;
    &.flexReverse {
      flex-direction: row-reverse
    }
    .customerProfile {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      img:not(.fb) {
        border-radius: 50%;
      }
      span {
        color: $gray-8;
        @include font-style(10px, 400, 14px);
        display: block;
        margin-top: 4px;
        max-width: 50px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .aboutQ {
      align-self: center;
      margin: {
        bottom: 19px;
        left: 10px;
      };
      &.v-btn--outline {
        background-color: $gray-1!important;
        border: 1px solid #DCDCDC!important;
        border-radius: 100px;
      }
      &.v-btn {
        min-width: 30px;
        width: 30px;
      }
      .v-btn__content {
        i {
          font-size: 20px;
          padding: 2px;
        }
        color: $gray-5;
      }
      &.v-btn:hover {
        &:before {
          opacity: 1;
          background-color: $pb_5;
        }
        .v-btn__content {
          color: white;
        }
        &.v-btn--outline {
          border: 1px solid #FFFFFF;
        }
      }
    }
    .chatBubbleWrap {
      min-width: 40px;
      max-width: 350px;
      color: $gray-8;
      &.cbWrapLeft {
        padding-left: 10px;
      }
      &.cbWrapRight {
        padding-right: 10px;
      }
      @include font-style(14px, 400, 20px);
      .chatBubble {
        padding: 10px;
        &.customer {
          position: relative;
          background-color: $gray-0;
          border-radius: 0 10px 10px 10px;
          .messageContentWrap {
            white-space: pre-line;
            word-break: break-all;
            a {
              text-decoration: underline;
            }
          }
        }
        &.systemUser {
          position: relative;
          background-color: #FFE0E0;
          border-radius: 10px 0 10px 10px;
          .messageContentWrap {
            white-space: pre-line;
            word-break: break-all;
            a {
              text-decoration: underline;
            }
          }
        }
      }
    }
    .messageDate {
      color: $gray-6;
      @include font-style(10px, 400, 14px);
      display: block;
      margin-top: 5px;
      &.left {
        text-align: left;
      }
      &.right {
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/chat_messages.vue